const roles = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  SUBSCRIBER: 'SUBSCRIBER',
  AFFILIATE: 'AFFILIATE',
};

export default roles;
